const userAuthPayloaddata = (data) =>
{
	console.log('function in userAuthPayloaddata', data);
	const obj={
		attributes : {
			custom : { domain: data.domain, fname: data.firstName },
			email  : data.email,
			name   : data.firstName,
			sub    : data.userId

		},
		username : data.userId

	};

	return obj;

};

export default userAuthPayloaddata;